
import { useApplicationsService } from './useApplicationsService'
import { useContactService } from './useContactService'

export const useNotificationBadges = () => {
    const { getApplications } = useApplicationsService()
    const { getMessages } = useContactService()

    // Global state for badges to be shared across components if needed
    const badges = useState('notification-badges', () => ({
        applications: 0,
        messages: 0
    }))

    const fetchBadges = async () => {
        try {
            // Fetch applications and count 'Pending'
            const apps = await getApplications()
            const pendingApps = apps.filter(a => a.status === 'Pending')

            // Fetch messages and count unread
            const msgs = await getMessages()
            const unreadMsgs = msgs.filter(m => !m.isRead)

            badges.value = {
                applications: pendingApps.length,
                messages: unreadMsgs.length
            }
        } catch (e) {
            console.error('Error fetching notification badges:', e)
        }
    }

    return {
        badges,
        fetchBadges
    }
}
